module.exports = __webpack_public_path__ + "img/allthat_main_banner_wonju2.10c92e06.png";